<template>
  <v-app>
    <v-content>
      <!-- Toolbar contains login and logo -->
      <toolbar></toolbar>

      <!-- Alert container for error messages -->
      <alert-container></alert-container>

      <!-- Breadcrumbs for navigation -->
      <v-breadcrumbs :items="breadcrumbs">
        <template v-slot:divider>
          <v-icon>forward</v-icon>
        </template>
        <v-breadcrumbs-item slot="item" slot-scope="{ item }" exact :to="item.href">{{ item.text }}</v-breadcrumbs-item>
      </v-breadcrumbs>

      <!-- Container for dynamic routes -->
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import store from "@/store.js";

import Toolbar from "@/components/Toolbar";
import AlertContainer from "@/components/AlertContainer";

import { discoveryDocs, clientId, scope } from "@/config.json";

export default {
  name: "App",
  components: {
    Toolbar,
    AlertContainer
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    }
  },
  created: function() {
    gapi.load("client", this.initClient);
  },
  methods: {
    checkSignInStatus() {
      const GoogleAuth = gapi.auth2.getAuthInstance();
      const GoogleManagement = gapi.client.analytics.management;
      this.$store.dispatch("setGoogleApi", gapi);
      this.$store.dispatch("setGoogleAuth", GoogleAuth);
      this.$store.dispatch("setGoogleManagement", GoogleManagement);
      this.$store.dispatch("checkSignInStatus");
    },
    initClient() {
      gapi.client
        .init({
          discoveryDocs,
          clientId,
          scope
        })
        .then(this.checkSignInStatus);
    }
  }
};
</script>

